function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React, { Fragment, useCallback, useEffect, useRef } from "react";
import { Tooltip } from "../../Tooltip";
import useStyle from "./Option.style";
import { injectTestId } from "@cvent/nucleus-test-automation";
var Option = function(_param) {
    var _focused = _param.focused, focused = _focused === void 0 ? false : _focused, id = _param.id, isRtl = _param.isRtl, onUpdate = _param.onUpdate, option = _param.option, optionIndex = _param.optionIndex, optionStyleObject = _param.optionStyleObject, _required = _param.required, required = _required === void 0 ? false : _required, _selected = _param.selected, selected = _selected === void 0 ? false : _selected, setCurrentFocus = _param.setCurrentFocus, testID = _param.testID, theme = _param.theme, rest = _objectWithoutProperties(_param, [
        "focused",
        "id",
        "isRtl",
        "onUpdate",
        "option",
        "optionIndex",
        "optionStyleObject",
        "required",
        "selected",
        "setCurrentFocus",
        "testID",
        "theme"
    ]);
    var optionRef = useRef(null);
    var destructive = option.destructive, disabled = option.disabled, heading = option.heading, label = option.label, lineBreak = option.lineBreak, secondary1 = option.secondary, tooltipText = option.tooltipText, value = option.value;
    var ref4 = useStyle({
        destructive: destructive,
        disabled: disabled,
        heading: heading,
        focused: focused,
        isRtl: isRtl,
        isSelected: selected
    }), firstOptionHeadingStyles = ref4.firstOptionHeadingStyles, labelContainerStyles = ref4.labelContainerStyles, listItemBackgroundStyles = ref4.listItemBackgroundStyles, listItemStyles = ref4.listItemStyles, lineBreakStyles = ref4.lineBreakStyles, optionDestructiveStyles = ref4.optionDestructiveStyles, optionDisabledStyles = ref4.optionDisabledStyles, optionHeadingStyles = ref4.optionHeadingStyles, secondaryContainerStyles = ref4.secondaryContainerStyles, secondaryListItemStyles = ref4.secondaryListItemStyles;
    useEffect(function() {
        if ((optionRef === null || optionRef === void 0 ? void 0 : optionRef.current) && focused) {
            optionRef.current.focus();
        }
    }, [
        focused,
        optionRef
    ]);
    var handleSelect = useCallback(function() {
        if (onUpdate) {
            setTimeout(function() {
                return onUpdate(option, optionIndex);
            }, parseFloat(theme.transition.duration.default) * 1);
        }
    }, [
        onUpdate,
        option,
        optionIndex,
        theme
    ]);
    var handleClick = function(event) {
        event.stopPropagation();
        if (!(heading || disabled)) {
            if (optionRef === null || optionRef === void 0 ? void 0 : optionRef.current) {
                optionRef.current.focus();
            }
            handleSelect();
        }
    };
    var handleMouseDown = function() {
        var ref, ref1;
        var ref2, ref3;
        if ((optionRef === null || optionRef === void 0 ? void 0 : optionRef.current) && ((ref2 = (ref = optionRef.current.parentElement) === null || ref === void 0 ? void 0 : ref.scrollTop) !== null && ref2 !== void 0 ? ref2 : 0) > optionRef.current.offsetTop - ((ref3 = (ref1 = optionRef.current.parentElement) === null || ref1 === void 0 ? void 0 : ref1.clientHeight) !== null && ref3 !== void 0 ? ref3 : 0) + 1) {
            optionRef.current.focus();
            if (setCurrentFocus) {
                setCurrentFocus(optionIndex);
            }
        }
    };
    var handleKeyDown = function(event) {
        if (!(heading || disabled) && (optionRef === null || optionRef === void 0 ? void 0 : optionRef.current) && event.key === 'Enter') {
            optionRef.current.focus();
            handleSelect();
        }
    };
    var listItemCss = [
        listItemStyles,
        optionStyleObject,
        heading ? optionHeadingStyles : {},
        heading && optionIndex === 0 ? firstOptionHeadingStyles : {},
        disabled ? optionDisabledStyles : {},
        destructive ? optionDestructiveStyles : {}
    ];
    var formatLabel = function() {
        var formattedLabel = label;
        if (typeof formattedLabel === 'function') {
            return formattedLabel(theme);
        }
        return formattedLabel;
    };
    var listItem = _jsxs("li", _objectSpread({}, rest, {
        id: id,
        css: [
            listItemCss,
            listItemBackgroundStyles
        ],
        tabIndex: -1,
        onClick: handleClick,
        onMouseDown: handleMouseDown,
        onKeyDown: handleKeyDown,
        role: heading ? 'separator' : 'menuitem',
        ref: optionRef,
        className: focused ? 'optionFocused' : undefined
    }, injectTestId(testID && "".concat(testID, "-option").concat(optionIndex !== undefined ? "-".concat(optionIndex) : '')), disabled ? {
        'aria-disabled': true
    } : undefined, destructive ? {
        'aria-label': "".concat(typeof label === 'string' ? label : value, ", option is destructive")
    } : undefined, {
        children: [
            _jsx("div", {
                css: labelContainerStyles,
                children: formatLabel()
            }),
            !heading && secondary1 && _jsx("ul", {
                css: secondaryContainerStyles,
                children: secondary1.map(function(secondary, index) {
                    return _jsx("li", {
                        css: secondaryListItemStyles,
                        children: typeof secondary === 'string' ? secondary : secondary === null || secondary === void 0 ? void 0 : secondary.value
                    }, index);
                })
            })
        ]
    }));
    return _jsxs(Fragment, {
        children: [
            lineBreak && _jsx("div", {
                css: lineBreakStyles
            }),
            tooltipText && _jsx(Tooltip, {
                portal: true,
                text: tooltipText,
                trigger: function(openTooltip, closeTooltip, ref) {
                    return _jsx("div", {
                        ref: ref,
                        onMouseEnter: openTooltip,
                        onMouseLeave: closeTooltip,
                        onFocus: openTooltip,
                        onBlur: closeTooltip,
                        children: listItem
                    });
                }
            }) || listItem
        ]
    });
};
export { Option };
export default Option;
